/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
const supported = typeof window == 'undefined' ? true : 'onscrollend' in window;

if (!supported) {
  const pointers = new Set();

  // Track if any pointer is active
  document.addEventListener(
    'touchstart',
    (e) => {
      for (const touch of e.changedTouches) pointers.add(touch.identifier);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    (e) => {
      for (const touch of e.changedTouches) pointers.delete(touch.identifier);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchcancel',
    (e) => {
      for (const touch of e.changedTouches) pointers.delete(touch.identifier);
    },
    { passive: true }
  );

  // Map of scroll-observed elements.
  const observed = new WeakMap();

  // Forward and observe calls to a native method.
  // @ts-expect-error polyfill from js
  function observe(proto, method, handler) {
    const native = proto[method];
    proto[method] = function () {
      // eslint-disable-next-line prefer-rest-params
      const args = Array.prototype.slice.apply(arguments, [0]);
      native.apply(this, args);
      args.unshift(native);
      handler.apply(this, args);
    };
  }

  // @ts-expect-error polyfill from js
  function onAddListener(this: any, originalFn, type, handler, options) {
    // Polyfill scrollend event on any element for which the developer listens
    // to 'scrollend' explicitly or 'scroll' (so that adding a scrollend listener
    // from within a scroll listener works).
    if (type != 'scroll' && type != 'scrollend') return;

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const scrollport = this;
    let data = observed.get(scrollport);
    if (data === undefined) {
      let timeout = 0;
      data = {
        scrollListener: () => {
          clearTimeout(timeout);
          // @ts-expect-error polyfill from js
          timeout = setTimeout(() => {
            if (pointers.size) {
              // if pointer(s) are down, wait longer
              setTimeout(data.scrollListener, 100);
            } else {
              // dispatch
              if (scrollport) {
                scrollport.dispatchEvent(new Event('scrollend'));
              }
              timeout = 0;
            }
          }, 100);
        },
        listeners: 0, // Count of number of listeners.
      };
      originalFn.apply(scrollport, ['scroll', data.scrollListener, { passive: true }]);
      observed.set(scrollport, data);
    }
    data.listeners++;
  }

  function onRemoveListener(
    this: any,
    originalFn: { apply: (arg0: any, arg1: any[]) => void },
    type: string,
    handler: any
  ) {
    if (type != 'scroll' && type != 'scrollend') return;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const scrollport = this;
    const data = observed.get(scrollport);

    // Mismatched addEventListener / removeEventListener
    // TODO: Should we explicitly track added listeners to prevent this?
    if (data === undefined) return;

    // If there are still listeners, nothing more to do.
    if (--data.listeners > 0) return;

    // Otherwise, remove the added listeners.
    originalFn.apply(scrollport, ['scroll', data.scrollListener]);
    observed.delete(scrollport);
  }

  observe(Element.prototype, 'addEventListener', onAddListener);
  observe(window, 'addEventListener', onAddListener);
  observe(document, 'addEventListener', onAddListener);
  observe(Element.prototype, 'removeEventListener', onRemoveListener);
  observe(window, 'removeEventListener', onRemoveListener);
  observe(document, 'removeEventListener', onRemoveListener);
  // TODO: Polyfill onscroll, onscrollend as well?
}
